<script lang="ts">
  import type { ResponseSnapshot } from '../../lib/types';

  export let response: ResponseSnapshot;

  function formatAnswer(question: ResponseSnapshot['questions'][number]): string {
    const raw = response.answers[question.id];
    if (raw === undefined || raw === null || raw === '') return '—';
    const optionLabel = (value: string) =>
      question.options?.find(option => option.value === value)?.label ?? value;
    if (Array.isArray(raw)) {
      return raw.length ? raw.map(optionLabel).join(', ') : '—';
    }
    if (typeof raw === 'boolean') return raw ? 'Yes' : 'No';
    if (question.type === 'select') return optionLabel(String(raw));
    return String(raw);
  }
</script>

<dl class="answers">
  {#each response.questions as question (question.id)}
    <div class="answers__row">
      <dt>{question.prompt}</dt>
      {#if question.type === 'image'}
        <dd>
          {#if response.imageUrls?.[question.id]}
            <a href={response.imageUrls[question.id]} target="_blank" rel="noopener noreferrer">
              <img class="answers__image" src={response.imageUrls[question.id]} alt={question.prompt} loading="lazy" />
            </a>
          {:else}
            —
          {/if}
        </dd>
      {:else}
        <dd>{formatAnswer(question)}</dd>
      {/if}
    </div>
  {/each}
</dl>

<style>
  .answers {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
  }

  .answers__row {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .answers__row dt {
    font-size: var(--font-size-xs);
    color: var(--color-text-muted);
  }

  .answers__row dd {
    margin: 0;
    font-size: var(--font-size-sm);
    color: var(--color-text-secondary);
    white-space: pre-wrap;
  }

  .answers__image {
    display: block;
    max-width: min(100%, 200px);
    max-height: 200px;
    border-radius: var(--radius-sm);
    border: var(--border-subtle);
    object-fit: cover;
  }
</style>
